import { ApplicationNextStep } from './ApplicationNextStep';

export interface ApplicationStatusLegendEntry {
  status: string;
  name: string;
  value: number;
  percentage: number;
  color: string;
}

/** Counts and percentages are supplied unchanged from each dashboard's chart data. */
export function ApplicationStatusLegend({ entries }: { entries: ApplicationStatusLegendEntry[] }) {
  return <div className="mt-3">
    {entries.map(item => (
      <div key={item.status} className="d-flex align-items-start justify-content-between gap-2 mb-3">
        <div className="d-flex align-items-start" style={{ minWidth: 0 }}>
          <div className="rounded-circle me-2" aria-hidden="true"
            style={{ width: '12px', height: '12px', backgroundColor: item.color, flexShrink: 0, marginTop: '6px' }} />
          <div style={{ minWidth: 0, overflowWrap: 'anywhere' }}><span className="text-muted">{item.name}</span><ApplicationNextStep status={item.status} /></div>
        </div>
        <div className="text-end flex-shrink-0">
          <div className="fw-semibold">{item.value}</div>
          <small className="text-muted">{item.percentage}%</small>
        </div>
      </div>
    ))}
    {entries.length === 0 && <div className="text-center text-muted py-4"><p className="mb-0">No applications yet</p></div>}
  </div>;
}
